import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }

import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import epinioAuth from '../../utils/auth';
import Banner from '@components/Banner/Banner.vue';
import { dashboardUrl } from '../../utils/embedded-helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'verify',
  setup(__props) {

const store = useStore();
const error = ref<string>('');

onMounted(async () => {
  const { 
    error: routeError, 
    error_description: errorDescription,
  } = store.$router.currentRoute._value.query;
  
  error.value = errorDescription || routeError;

  if (error.value) {
    console.error('Dex indicates failure', error);
  } else {
    await epinioAuth.dexRedirect(store.$router.currentRoute, {
      dexUrl:       sessionStorage.getItem('epinio-dex-url') || document.referrer,
      dashboardUrl: dashboardUrl()
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(error.value) + " ", 1),
    _createElementVNode("main", _hoisted_1, [
      (error.value)
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: error.value
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-center mt-50" }, "\n      Logging In…\n    ", -1))
    ])
  ], 64))
}
}

})